import {
  AppBar,
  Button,
  Container,
  Stack,
  Toolbar
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Appinfo } from "../common/config";
import Logo from "../ui/logo";

export default function WebSiteHome() {
  const navigate = useNavigate();
  return (
    <Stack>
      <AppBar component="nav">
        <Toolbar>
          <Logo title={Appinfo.name} />
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg">
        <Toolbar></Toolbar>
        <Stack
          sx={{ p: 5, height: "80vh" }}
          alignItems="center"
          justifyContent="center"
          spacing={10}>
          <img src="https://yun.gansudaily.com.cn/material-icons/news/mgnewsqr.jpg" alt="" />
          <Button
            size="large"
            variant="contained"
            onClick={() => {
              navigate("/1");
            }}>
            login
          </Button>
        </Stack>
      </Container>
    </Stack>
  );
}
